module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticStyle: {
      "margin": "0",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "checkbox",
      "name": "MultiSelect"
    },
    domProps: {
      "checked": Array.isArray(_vm.status) ? _vm._i(_vm.status, null) > -1 : (_vm.status)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.status = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.status = $$c
        }
      }, _vm.toggle]
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53bd0f66!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue2-datatable-component/src/Table/MultiSelect.vue
// module id = 1290
// module chunks = 2